import React, { useEffect } from "react";
import { motion } from "framer-motion";
import ServicesComponent from "../components/Services";

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageVariants = {
    initial: { opacity: 0, x: -20 },
    in: { opacity: 1, x: 0 },
    out: { opacity: 0, x: 20 }
  };

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={{ duration: 0.5 }}
    >
      <ServicesComponent />
    </motion.div>
  );
};

export default Services;